module.exports = __webpack_public_path__ + "img/age-confirmation-bg.c321024e.png";